import find from 'lodash-es/find';
import { ScrollToService, IScrollToOptions } from '@df/dom/scroll/scroll-to.service';
import { Injectable } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';

@Injectable({
    providedIn: 'root'
})
export class ScrollToErrorService {
    constructor(
        private scrollToService: ScrollToService,
        private timeoutService: TimeoutService
    ) {}

    scrollTo(container: Element | Document = document, options: IScrollToOptions = {}) {
        this.timeoutService.setTimeout(() => {
            const errorElement = find(container.querySelectorAll('.ng-invalid'), i =>
                ['input', 'select', 'textarea'].includes(i.tagName.toLowerCase())
            );
            if (errorElement) {
                this.scrollToService.scrollTo(errorElement.parentElement || errorElement, options);
            }
        });
    }
}
